var _g, _path, _g2, _g3, _rect, _g4, _rect2, _rect3, _circle, _g5, _rect4, _rect5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpired(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4283_30102)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 29,
    width: 116,
    height: 106,
    rx: 12,
    fill: "url(#paint0_linear_4283_30102)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 49H142V37C142 32.5817 138.418 29 134 29H34C29.5817 29 26 32.5817 26 37V49Z",
    fill: "url(#paint1_linear_4283_30102)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_4283_30102)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 38.5,
    r: 3.5,
    fill: "#D3D8E0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_4283_30102)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 38.5,
    r: 3.5,
    fill: "#D3D8E0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4283_30102",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 29,
    width: 116,
    height: 106
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 29,
    width: 116,
    height: 106,
    rx: 12,
    fill: "url(#paint2_linear_4283_30102)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4283_30102)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122 163C150.719 163 174 139.719 174 111C174 82.2812 150.719 59 122 59C111.074 59 100.935 62.3697 92.5659 68.1265L85.8537 61.4143C85.0726 60.6332 83.8063 60.6332 83.0252 61.4143L71.7704 72.6691C70.9894 73.4501 70.9894 74.7165 71.7704 75.4975L78.6076 82.3347C73.1677 90.5529 70 100.407 70 111C70 139.719 93.2812 163 122 163Z",
    fill: "url(#paint3_linear_4283_30102)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 77.8828,
    y: 75.832,
    width: 12,
    height: 20,
    transform: "rotate(-45 77.8828 75.832)",
    fill: "#FF695C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 87.5566,
    y: 63,
    width: 8,
    height: 20,
    rx: 2,
    transform: "rotate(45 87.5566 63)",
    fill: "#FF937B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 111,
    r: 39,
    stroke: "url(#paint4_linear_4283_30102)",
    strokeWidth: 12
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_4283_30102)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 111,
    r: 33,
    fill: "url(#paint5_linear_4283_30102)"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 111.657,
    width: 10,
    height: 24,
    rx: 5,
    transform: "rotate(-45 116 111.657)",
    fill: "url(#paint6_linear_4283_30102)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 89,
    width: 10,
    height: 26,
    rx: 5,
    fill: "#FF977D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4283_30102",
    x: 26,
    y: 29,
    width: 116,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.490833 0 0 0 0 0.538333 0 0 0 0 0.633333 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4283_30102"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_4283_30102",
    x: 36,
    y: 35,
    width: 8.17862,
    height: 8.17862,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.17862,
    dy: 1.17862
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.17862
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.173056 0 0 0 0 0.271944 0 0 0 0 0.370833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4283_30102"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_4283_30102",
    x: 51,
    y: 35,
    width: 8.17862,
    height: 8.17862,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.17862,
    dy: 1.17862
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.17862
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.173056 0 0 0 0 0.271944 0 0 0 0 0.370833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4283_30102"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_4283_30102",
    x: 89,
    y: 78,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9025 0 0 0 0 0.909286 0 0 0 0 0.95 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4283_30102"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4283_30102",
    x1: 9.5,
    y1: 82,
    x2: 150.344,
    y2: 86.6939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0095307,
    stopColor: "#EBEDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4283_30102",
    x1: 28.6605,
    y1: 38.2857,
    x2: 141.988,
    y2: 39.8711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0095307,
    stopColor: "#E1E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8DCE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4283_30102",
    x1: 10,
    y1: 82,
    x2: 141.854,
    y2: 86.3943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#F7F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4283_30102",
    x1: 139.5,
    y1: 73.5,
    x2: -18,
    y2: 74.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E3EC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4283_30102",
    x1: 100.967,
    y1: 75.2935,
    x2: 146.946,
    y2: 148.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4E49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4283_30102",
    x1: 103.025,
    y1: 85.425,
    x2: 136.437,
    y2: 139.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F4FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4283_30102",
    x1: 121,
    y1: 111.657,
    x2: 121,
    y2: 137.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF977D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpired);
export default __webpack_public_path__ + "static/media/expired.1075f89f2e7f7bd931c9adc2fbb799f9.svg";
export { ForwardRef as ReactComponent };